const blogs = [
    {
      id: 1,
      title: "Partnered Up with Google",
      author: "Roberta Casas",
      date: "Aug 15, 2021",
      readTime: 16,
      excerpt: "Over the past year, Volosoft has undergone many changes! After months of preparation...",
      imageUrl: "https://via.placeholder.com/350x350"
    },
    {
      id: 2,
      title: "Our First Office",
      author: "Jese Leos",
      date: "Aug 15, 2021",
      readTime: 16,
      excerpt: "Over the past year, Volosoft has undergone many changes! After months of preparation...",
      imageUrl: "https://via.placeholder.com/350x350"
    },
    {
      id: 3,
      title: "Our First Project with React",
      author: "Sofia McGuire",
      date: "Aug 15, 2021",
      readTime: 16,
      excerpt: "Over the past year, Volosoft has undergone many changes! After months of preparation...",
      imageUrl: "https://via.placeholder.com/350x350"
    }
  ];

export default blogs;  